import * as CubeTree from '../../cubeTree/index';

function forceUpdateList(moveTask: MoveTask): CubeId[] {
    let result: Set<CubeId> = new Set();

    moveTask.logic.forEach((logicTask: LogicMoveTask): void => {
        // 商品跨横杆移动时，需要强制更新cube dom结构
        if (CubeTree.isGoods(logicTask.from.moveTarget)
            && toBeam(logicTask.from.parent, logicTask.to.parent)) {
            result.add(logicTask.from.moveTarget);
        }
    });

    return Array.from(result);
}

// 是否跨横杆
function toBeam(from: CubeId, to: CubeId): boolean {
    // 非横杆之间的商品移动
    if (!CubeTree.isBeam(from) && !CubeTree.isBeam(to)) {
        return false;
    }

    // 横杆之间的商品移动
    if (CubeTree.isBeam(from) && CubeTree.isBeam(to)) {
        return false;
    }

    return true;
}

export {
    forceUpdateList
};
